import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import axios from "axios";
import {
  addEmployeeUrl,
  deleteEmployeeUrl,
  getEmployeesUrl,
  getOwnersUrl,
  updateStaffUrl,
  getRolesAndPermissionUrl,
} from "../urls";

// Get employee details
export const getEmployeeDetailsAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(
        getEmployeesUrl(),
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message:
          err.response?.data?.message || "Failed to fetch employee details",
      });
    }
  });
};

// Get allowed roles and permissions for the employee
export const getRolesAndPermissionDetailsAction = async (firmID) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(
        getRolesAndPermissionUrl(firmID),
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message:
          err.response?.data?.message ||
          "Failed to fetch roles and permissions",
      });
    }
  });
};

// Add member
export const addMemberAction = async (data) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.post(
        addEmployeeUrl(),
        data,
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message: err.response?.data?.message || "Failed to add member details",
      });
    }
  });
};

// Get owner Details
export const getOwnerDetailsAction = async (firmID) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(
        getOwnersUrl(firmID),
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message: err.response?.data?.message || "Failed to fetch owner details",
      });
    }
  });
};

// Update staff details (whatsapp number)
export const updateStaffAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(updateStaffUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({
          error: true,
          message:
            err.response?.data?.message || "Failed to update staff details",
        });
      });
  });
};

// Delete employee
export const deleteEmployeeAction = async (staff_id, firm_id) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.delete(
        deleteEmployeeUrl(staff_id, firm_id),
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message: err.response?.data?.message || "Failed to delete the employee",
      });
    }
  });
};